import { HttpClient } from '@angular/common/http';
import { HttpService } from '@rx-applications/shared/utils';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { Credentials, LoginResponseInterface } from '../../models';

export abstract class BackendAbstractService<SignupInformationInterface> {
  protected http: HttpClient = inject(HttpClient);
  protected httpService: HttpService = inject(HttpService);

  abstract login(credentials: Credentials, usertype?: string): Observable<LoginResponseInterface>;

  abstract impersonate(credentials: Credentials, usertype?: string): Observable<LoginResponseInterface>;

  abstract requestPassword(email: string): Observable<null>;

  abstract resetPassword(password: string, token: string, email?: string): Observable<null>;

  abstract signup(formData: SignupInformationInterface): Observable<null>;

  abstract activateAccount(confirmCode: string): Observable<null>;

  getDomain(username: string): Observable<string> {
    return this.http.get<string>(`${this.httpService.authApiUrl}GetUserDomain?username=${username}`);
  }
}
